// src/app/auth/auth-guard.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { MemberRoleEnum, UserDutyEnum } from 'src/enumerators';
import { environment } from 'src/environments/environment';
import { User } from 'src/models';
import { AuthService } from './auth.service';
import { OrganizationService } from './organization.service';
import { ToastService } from './toast.service';
@Injectable()
export class AuthGuardService {
  endpoint = environment.endpoint();
  _urlCheckInvite = '/organization/check-invite?accessCode=';
  _urlCheckPassToken = '/password-recovery?token=';
  accessCode: string;
  passToken: string;
  userSub: BehaviorSubject<User> = new BehaviorSubject(undefined);
  constructor(
    public _auth: AuthService,
    public _router: Router,
    private _http: HttpClient,
    private _activedRoute: ActivatedRoute,
    private _organizationService: OrganizationService,
    private _toastService: ToastService,
  ) { }

  //If false, we send the user back to '/login' page
  canActivate(): boolean {
    var userDuty: UserDutyEnum;
    if (!this._auth.loggedUser) {
      this._auth.currentUser().subscribe((user: User) => {
        this._auth.loggedUser = user;
        userDuty = this._auth.loggedUser.duty;
        if (userDuty == UserDutyEnum.Master) {
          this._router.navigate(['/master']);
        }
        this.userSub.next(user);
      }, error => {
        this._router.navigate(['/login']);
      });
    } else {
      this.userSub.next(this._auth.loggedUser);
    }
    if (!this._auth.isLoggedIn()) {
      this._router.navigate(['/login']);
      return false;
    }
    return true;
  }

  checkOwnerInvite(): Observable<any> {
    return this._activedRoute.queryParams.pipe(
      map(params => params['accessCode']),
      filter((code): code is string => !!code),
      switchMap(accessCode =>
        this._http.get<any>(`${this.endpoint}${this._urlCheckInvite}${accessCode}`)
      ),
      tap(response => {
        this._organizationService.newOrganizationId = response.organizationId;

        if (response.userAlreadyExist) {
          // Usuário já tem conta: check-invite é só leitura. Encaminha para a
          // tela dedicada, que faz o aceite explícito (POST /accept-invite).
          this._router.navigate(['/login/invite-accepted'], {
            state: { firstName: response.firstName, accessCode: response.accessCode },
          });
        }
      }),
      catchError(error => {
        this._router.navigate(['/login']);
        return EMPTY;
      })
    );
  }

  public checkPassToken() {
    this._activedRoute.queryParams.subscribe((res) => (this.passToken = res.token));
    const url = this.endpoint + this._urlCheckPassToken + this.passToken;
    return this._http.get<any>(url).pipe(
      tap(
        (next) => { },
        (error) => {
          this._router.navigate(['/login']);
        },
      ),
    );
  }
  public checkForPermission(invalidPermissions: Array<MemberRoleEnum>) {
    const isInvalid = invalidPermissions.some((duty) => {
      return duty == this._auth?.currentMember?.role;
    });
    if (isInvalid) {
      // O papel do membro não tem acesso a esta página. Em vez de encerrar a
      // sessão (que deslogava o usuário), redirecionamos para a home, que é
      // acessível a todos os papéis.
      this._toastService.showError('Você não tem permissão para acessar esta página.');
      this._router.navigate(['/']);
    }
    return isInvalid;
  }
}
